var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.load)?_c('div',{staticClass:"loadComp"},[_c('spinner-1',{staticClass:"spinner",attrs:{"animation-duration":2000,"size":60,"color":'#ff8200'}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }